import { render, staticRenderFns } from "./dsf-app-wrapper.vue?vue&type=template&id=c320ba1c"
import script from "./dsf-app-wrapper.vue?vue&type=script&lang=js"
export * from "./dsf-app-wrapper.vue?vue&type=script&lang=js"
import style0 from "./dsf-app-wrapper.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports